import {Injectable} from "@angular/core";
import {BaseApiService} from "../services/base-api-service";
import {Observable} from "rxjs";
import {Product, ProductsApiResponse} from "../interfaces/Product";
import {ApiType} from "../enums/api-type";
import {RequestType} from "../enums/RequestType";
import {RatingApiResponse} from "../interfaces/Rating";

@Injectable({providedIn: 'root'})
export class ProductApi {

  constructor(
    private readonly apiClient: BaseApiService
  ) {
  }

  getProductById(id: string, withRecommendations: boolean): Observable<Product> {
    return  this.apiClient.call<{}, Product>({
      apiType: ApiType.getProductById,
      pathVariables: [id],
      requestType: RequestType.GET,
      body: withRecommendations ? {
        "withRecommendations": withRecommendations
      } : {}
    })
  }

  getAllProducts(): Observable<ProductsApiResponse> {
    return this.apiClient.call<null, ProductsApiResponse>({
      apiType: ApiType.getAllProducts,
      requestType: RequestType.GET
    })
  }

  getProductReviews(id: string): Observable<RatingApiResponse> {
    return this.apiClient.call<{}, RatingApiResponse>({
      apiType: ApiType.getProductRating,
      requestType: RequestType.GET,
      pathVariables: [id]
    })
  }

  writeReview(id: string, rate: number, comment: string) : Observable<void> {
    let body: { [key: string]: any } = {
      rating: rate
    }
    if (comment.length > 0) {
      body['comment'] = comment
    }
    return this.apiClient.call<{}, void>({
      apiType: ApiType.addProductRating,
      requestType: RequestType.POST,
      body: body,
      pathVariables: [id]
    })
  }
}
